import { Menu } from "@interstate/components/Menu/Menu/Menu";
import type { MenuProps } from "@interstate/components/Menu/Types/menuTypes";
import type { ButtonProps } from "@interstate/components/Button";
import { Button } from "@interstate/components/Button";
import { useMenu } from "@interstate/components/Menu";

export interface MenuButtonProps {
  MenuProps: Omit<MenuProps, "referenceProps"> & {
    menuOptions: NonNullable<MenuProps["menuOptions"]>;
  };
  ButtonProps: Omit<ButtonProps, "onClick">;
  children?: React.ReactNode;
}

export const MenuButton = (props: MenuButtonProps) => {
  const menuReferenceProps = useMenu();
  const handleMenuClick = menuReferenceProps.onClick;

  return (
    <>
      <Button {...props.ButtonProps} onClick={handleMenuClick}>
        {props.children}
      </Button>
      <Menu
        {...props.MenuProps}
        referenceProps={menuReferenceProps.referenceProps}
      />
    </>
  );
};
